import { color } from "@smoothincorg/smooth-ui"
import React from "react"
import { HiExternalLink } from "react-icons/hi"
import { formatDate } from "src/components/List/List"
import { Card } from "src/components/page-directory/Card"
import { MainExamination } from "src/features/lifftter/hooks/useMainExaminationSWR"
import { MainExaminationScore } from "src/hooks/useMainExaminationScoresSWR"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { camelCase } from "src/lib/aikagi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"
import { RESTRICTED_ADMIN_URL, V1_OPE_URL } from "src/lib/constants/value"
import useSWR from "swr"
import { ModalEditableForm } from "../ModalEditableForm/ModalEditableForm"
import * as styles from "./MovingApplications.css"

export const useMainExaminationsSWR = (movingApplicationId: number) => {
  const { getWithToken } = useSmoothApi()
  return useSWR(
    `${SMOOTH_SMOOTHER_API_URL}/moving_applications/${movingApplicationId}/main_examinations`,
    async (url) => {
      const response = await getWithToken(url)
      const mainExaminations = response.data["data"].map((d: MainExamination) =>
        camelCase(d)
      ) as MainExamination[]

      const fetchScoresPromises = mainExaminations.map(async (mainExamination) => {
        const response = await getWithToken(
          `${SMOOTH_SMOOTHER_API_URL}/main_examinations/${mainExamination.id}/main_examination_score`
        )
        const mainExaminationScore = camelCase(response.data["data"] as MainExaminationScore)
        return { ...mainExamination, mainExaminationScore }
      })

      const result = await Promise.all(fetchScoresPromises)

      return result
    }
  )
}

export const MainExaminations: React.FC<{
  movingApplicationId: number
}> = ({ movingApplicationId }) => {
  const resourceName = `MovingApplication.${movingApplicationId}.MainExaminations`
  const mainExaminationsSWR = useMainExaminationsSWR(movingApplicationId)

  const mainExaminations = mainExaminationsSWR.data

  return (
    <div className={styles.root}>
      <h2 className={styles.title}>審査結果（{mainExaminationsSWR?.data?.length || 0}）</h2>
      <section>
        {mainExaminationsSWR.isValidating ? (
          <p>読み込み中...</p>
        ) : !mainExaminations?.length ? (
          <p>審査結果が登録されていません</p>
        ) : null}
        {mainExaminations?.map((mainExamination) => (
          <Card key={mainExamination?.id} className={styles.destinationAddress}>
            <ModalEditableForm
              resourceName={resourceName}
              resource={mainExamination}
              opeHref={
                mainExamination
                  ? V1_OPE_URL + "/admin/main_examinations/" + mainExamination.id
                  : null
              }
              temporary_EDIT_IN_SMOOTHER_OPE_URL={
                mainExamination
                  ? V1_OPE_URL + "/admin/main_examinations/" + mainExamination.id
                  : null
              }
              items={
                mainExamination
                  ? [
                      ["Cic Examination", mainExamination.cicExamination],
                      ["Smooth Examined At", formatDate(mainExamination.smoothExaminedAt)],
                      ["特例", `${mainExamination.exception}`],
                      ["特例による調整金額", mainExamination.additionalAmountByExeption],
                      ["Created At", formatDate(mainExamination.createdAt)],
                      ["Updated At", formatDate(mainExamination.updatedAt)],
                      [
                        "AI与信結果",
                        <a
                          key={mainExamination.id}
                          href={
                            RESTRICTED_ADMIN_URL +
                            "/examinations/" +
                            mainExamination.mainExaminationScore?.autoExaminationLabel
                          }
                          style={{
                            textDecoration: "underline",
                            color: color.main,
                          }}
                          target="_blank"
                        >
                          Restricted個別審査画面
                          <HiExternalLink />
                        </a>,
                      ],
                      [
                        "MainExaminationScore",
                        <a
                          key={mainExamination.mainExaminationScore?.id}
                          href={
                            V1_OPE_URL +
                            "/admin/main_examination_scores/" +
                            mainExamination.mainExaminationScore?.id
                          }
                          style={{
                            textDecoration: "underline",
                            color: color.main,
                          }}
                          className={styles.mainExaminationScoreItem}
                          target="_blank"
                        >
                          ID:{` `}
                          {mainExamination.mainExaminationScore?.id}
                          <HiExternalLink />
                        </a>,
                      ],
                      ["Result", mainExamination.mainExaminationScore?.result],
                      ["LendableLoan", mainExamination.mainExaminationScore?.lendableLoan],
                    ]
                  : []
              }
              onSubmit={null}
            ></ModalEditableForm>
          </Card>
        ))}
      </section>
    </div>
  )
}
